import type { Prio } from '@/components/landing-page/landing-page.types';
import Accordion from '@/components/landing-page/components/accordion';
import Advantages from '@/components/landing-page/components/advantages';
import Contact from '@/components/landing-page/components/contact';
import CtaButton from '@/components/landing-page/components/cta-button';
import OrderedList from '@/components/landing-page/components/ordered-list';
import Review from '@/components/landing-page/components/review';
import Logos from '@/components/logos';
import Track from '@/utils/track';
import Certifications from '@/components/certifications';
import PRIO_GROUP_TYPE from '@/components/landing-page/utils/prio-group-type';
import { useAppSelector } from '@/redux/store';
import { ConfigSlice } from '@/redux/config';

const prio: Prio = {
  variation: [
    {
      color: '#00b649',
      order: ['title', 'html', 'list'],
      head: 2,
      title: 2,
      list: 2,
      html: -1,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // Pass und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Pass und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      color: '#ec2556',
      order: ['title', 'html', 'list'],
      head: 3,
      title: 3,
      html: 3,
      list: 1,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // No Pass, anderes Land
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Anderes Land',
                  },
                  { q17348: '2022>>>OR>>>2023>>>OR>>>2024>>>OR>>>2025>>>OR>>>2026' },
                  {
                    q17358:
                      '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19d>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 25a>>>OR>>>§ 25b>>>OR>>>§ 104c>>>OR>>>Sonstiges',
                  },
                  {
                    q17368:
                      '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Studium>>>NOT>>>Ausbildung',
                  },
                  {
                    q17377: 'Nein',
                  },
                  {
                    q17378: 'Nein',
                  },
                  { q18261: 'Ja' },
                ],
              },
            },
            {
              value: 'Einbürgerung', // No Pass, Not anderes Land, No exception
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: '>>>NOT>>>Anderes Land',
                  },
                  {
                    otherIdentificationDocument: 'Nein',
                  },
                  { q17348: '2022>>>OR>>>2023>>>OR>>>2024>>>OR>>>2025>>>OR>>>2026' },
                  {
                    q17358:
                      '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19d>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 25a>>>OR>>>§ 25b>>>OR>>>§ 104c>>>OR>>>Sonstiges',
                  },
                  {
                    q17368:
                      '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Studium>>>NOT>>>Ausbildung',
                  },
                  {
                    q17377: 'Nein',
                  },
                  {
                    q17378: 'Nein',
                  },
                  { q18261: 'Ja' },
                ],
              },
            },
          ],
        },
      },
    },
    {
      color: '#ffaa02',
      order: ['title', 'html', 'list'],
      head: 1,
      title: 1,
      html: 1,
      list: 1,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // Pass #1
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Anderes Land',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Pass #2
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: '>>>NOT>>>Anderes Land',
                  },
                  {
                    otherIdentificationDocument: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Aufenthaltsdauer
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17348: '2022>>>OR>>>2023>>>OR>>>2024>>>OR>>>2025>>>OR>>>2026>>>OR>>>Keine Angabe',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Befristeter Aufenthalt
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17358:
                      '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19d>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 25a>>>OR>>>§ 25b>>>OR>>>§ 104c>>>OR>>>Sonstiges',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Aufenthaltstitel
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17356: 'Duldung>>>OR>>>Fiktionsbescheinigung>>>OR>>>Ich weiß es nicht',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17368:
                      '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Studium',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Sprachnachweis
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>Kein deutsches Sprachzertifikat',
                  },
                  {
                    q17377: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Einbürgerungstest
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17370: 'Nein',
                  },
                  {
                    q17378: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Bürgergeld
              extra: {
                mode: 'every',
                condition: [
                  {
                    q18261: '>>>NOT>>>Nein',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      color: '#00b649',
      order: ['title', 'html', 'list'],
      head: 4,
      title: 4,
      list: -1,
      html: 4,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q18261: '>>>NOT>>>Ja',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      color: '#ec2556',
      order: ['title', 'html', 'list'],
      head: 3,
      title: 3,
      list: -1,
      html: 5,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q18261: 'Ja',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      color: '#ec2556',
      order: ['title', 'html', 'list'],
      head: 3,
      title: 3,
      list: -1,
      html: 5,
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value:
                '>>>NOT>>>Einbürgerung>>>NOT>>>Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis>>>NOT>>>Sonstiges',
              extra: null,
            },
          ],
        },
      },
    },
  ],
  successBox: {
    head: [
      {
        variationId: 1,
        content: {
          primary: 'Vielen Dank für Ihre Anfrage:',
          secondary: 'Voraussetzungen nur teilweise erfüllt',
        },
        condition: null,
      },
      {
        variationId: 2,
        content: {
          primary: 'Vielen Dank für Ihre Anfrage:',
          secondary: 'Sie erfüllen alle Voraussetzungen!',
        },
        condition: null,
      },
      {
        variationId: 3,
        content: {
          primary: 'Vielen Dank für Ihre Anfrage:',
          secondary: '',
        },
        condition: null,
      },
      {
        variationId: 4,
        content: {
          primary: 'Vielen Dank für Ihre Anfrage bei PassExperten',
          secondary: '',
        },
        condition: null,
      },
    ],
    body: {
      title: [
        {
          variationId: 1,
          content: '',
          condition: null,
        },
        {
          variationId: 2,
          content:
            'Unsere Analyse hat ergeben, dass Sie alle Voraussetzungen für den Antrag auf die deutsche Staatsbürgerschaft erfüllen.',
          condition: null,
        },
        {
          variationId: 3,
          content: 'Leider können wir Ihnen aktuell nicht helfen',
          condition: null,
        },
        {
          variationId: 4,
          content:
            'Um eine abschließende Einschätzung vornehmen zu können, benötigen wir weiterführende Informationen. Ein Antrag könnte sich lohnen.',
          condition: null,
        },
      ],
      html: [
        {
          variationId: 1,
          content:
            '<div style="margin-top: -8px; margin-bottom: 16px; line-height: 24px; font-weight:300;">Sie erfüllen nur einige Voraussetzungen, um die deutsche Staatsbürgerschaft zu beantragen. Hier erfahren Sie, was das bedeutet und welche nächsten Schritte Sie eingehen können.</div>',
          condition: {
            forceResult: 'none',
            mode: 'some',
            screen: null,
            form: {
              q17347: [
                {
                  value: 'Einbürgerung',
                  extra: null,
                },
              ],
            },
          },
        },
        {
          variationId: 2,
          content: '',
          condition: {
            forceResult: 'none',
            mode: 'some',
            screen: null,
            form: {
              q17347: [
                {
                  value: 'Einbürgerung',
                  extra: null,
                },
              ],
            },
          },
        },
        {
          variationId: 3,
          content:
            '<div style="margin-top: -8px; margin-bottom: 16px; line-height: 24px; font-weight:300;">Basierend auf Ihren Angaben können wir unseren Service derzeit nicht anbieten. Wir empfehlen Ihnen, den Test regelmäßig durchzuführen, um sofort zu sehen, ob Sie die Voraussetzungen erfüllen.</div>',
          condition: {
            forceResult: 'none',
            mode: 'some',
            screen: null,
            form: {
              q17347: [
                {
                  value: 'Einbürgerung',
                  extra: null,
                },
              ],
            },
          },
        },
        {
          variationId: 4,
          content:
            '<div style="margin-top: -8px; margin-bottom: 16px; line-height: 24px; font-weight:300;">Ihr Anliegen ist uns wichtig, daher werden wir Ihre Anfrage umgehend bearbeiten.</div><div style="margin-bottom: 16px line-height: 24px; font-weight:300;">Ein Experte wird sich zeitnah telefonisch bei Ihnen melden, Ihnen sagen, ob die Chancen für Sie gut stehen und alle weiteren Schritte mit Ihnen besprechen. Und das Beste: <bold>Das Gespräch ist völlig kostenlos!</bold></div><div style="margin-top: 16px; line-height: 24px; font-weight:300;">Mit freundlichen Grüßen</br>Ihr Passexperten Team</div>',
          condition: {
            forceResult: 'none',
            mode: 'some',
            screen: null,
            form: {
              q17347: [
                {
                  value: 'Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis>>>OR>>>Sonstiges',
                  extra: null,
                },
              ],
            },
          },
        },
        {
          variationId: 5,
          content:
            '<div style="margin-top: -8px; margin-bottom: 16px; line-height: 24px; font-weight:300;">Basierend auf Ihren Angaben können wir unseren Service derzeit nicht anbieten. Wir empfehlen Ihnen, den Test regelmäßig durchzuführen, um sofort zu sehen, ob Sie die Voraussetzungen erfüllen.</div>',
          condition: {
            forceResult: 'none',
            mode: 'some',
            screen: null,
            form: {
              q17347: [
                {
                  value:
                    '>>>NOT>>>Einbürgerung>>>NOT>>>Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis>>>NOT>>>Sonstiges',
                  extra: null,
                },
                {
                  value: 'Unbefristetes Aufenthaltsrecht / Niederlassungserlaubnis',
                  extra: {
                    mode: 'every',
                    condition: [
                      {
                        q18261: 'Ja',
                      },
                    ],
                  },
                },
              ],
            },
          },
        },
      ],
      list: [
        {
          variationId: 1,
          content: {
            priority: ['exclamation', 'question', 'check', 'cross'],
            content: [
              {
                type: 'check',
                content:
                  '<span>Aufenthalt in Deutschland:</span><p>Es sieht aus als würden Sie die zeitlichen Voraussetzungen erfüllen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17348: [
                      {
                        value:
                          '2021>>>OR>>>2020>>>OR>>>2019>>>OR>>>2018>>>OR>>>2017>>>OR>>>2016>>>OR>>>2015>>>OR>>>2014>>>OR>>>2013>>>OR>>>2012 oder davor',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Aufenthalt in Deutschland:</span><p>Es sieht aus als würden Sie nicht die benötigten fünf Jahre Aufenthalt in Deutschland erfüllen. Es gibt Ausnahmen:</p><ol><li style="margin-top:16px;"><strong>Deutscher Ehepartner?</strong> Ehegatten deutscher Staatsangehöriger können bereits nach 3 statt 5 Jahren eingebürgert werden.</li><li style="margin-top:16px;"><strong>Miteinbürgerung?</strong> Ehegatten und minderjährige Kinder einer gleichzeitig eingebürgerten Person können unter vereinfachten Voraussetzungen mit eingebürgert werden.</li><li style="margin-top:16px;"><strong>Härtefall?</strong> In besonderen Einzelfällen ist eine Einbürgerung auch ohne Erfüllung aller Regelvoraussetzungen möglich.</li></ol><p>Mehr zu den Voraussetzungen der Einbürgerung <a href="https://passexperten.de/ratgeber/erleichterte-einbuergerung/" target="_blank">finden Sie in unserem Ratgeber</a>.</p><p><strong>Tipp:</strong> Halten Sie Ihren Aufenthaltstitel aktuell und verlängern Sie ihn rechtzeitig - Lücken im Status können die Frist neu starten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17348: [
                      {
                        value: '2022>>>OR>>>2023',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Aufenthalt in Deutschland:</span><p>Es sieht aus als würden Sie nicht die benötigten fünf Jahre Aufenthalt in Deutschland erfüllen.</p><p><strong>Tipp:</strong> Halten Sie Ihren Aufenthaltstitel aktuell und verlängern Sie ihn rechtzeitig - Lücken im Status können die Frist neu starten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17348: [
                      {
                        value: '2024>>>OR>>>2025>>>OR>>>2026',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Aufenthaltstitel:</span><p>Ihr Aufenthaltstitel ist für die Einbürgerung ausreichend.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Unbefristetes Aufenthaltsrecht>>>OR>>>EU-Bürger',
                        extra: null,
                      },
                      {
                        value: 'Befristetes Aufenthaltsrecht',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17358:
                                '>>>NOT>>>§ 19d>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 104c',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Duldung:</span><p>Achtung: Wahrscheinlich hatten Sie eine Duldung vor diesem Aufenthaltstitel. Man müsste sich Ihre Aufenthaltszeiten genauer ansehen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17358: [
                      {
                        value: '§ 19d>>>OR>>>§ 25a>>>OR>>>§ 25b',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Fiktionsbescheinigung:</span><p>Sie haben derzeit eine Fiktionsbescheinigung. Das ist kein Problem. Sie sollten allerdings Druck auf die Ausländerbehörde aufbauen. Mit einer Fiktionsbescheinigung können Sie nicht eingebürgert werden.Sie sollten den dafür vorhergesehenen Aufenthaltstitel vorweisen können.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Fiktionsbescheinigung',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Duldung:</span><p>Eine Duldung ist kein geeigneter Aufenthaltstitel für die Einbürgerung. Prüfen Sie, ob Sie die Voraussetzungen für eine Aufenthaltserlaubnis erfüllen, da diese für eine Einbürgerung erforderlich ist.</p><p><strong>Tipp:</strong> Prüfen Sie beim zuständigen Ausländeramt, ob Sie bereits die Voraussetzungen für eine Niederlassungserlaubnis erfüllen - das ist oft der direkteste Weg.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Duldung',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Aufenthaltstitel:</span><p>Ihr Aufenthaltstitel könnte für die Einbürgerung nicht ausreichen. Prüfen Sie, ob Sie die Voraussetzungen für eine Aufenthaltserlaubnis erfüllen, da diese für eine Einbürgerung erforderlich ist. Weiterführende Informationen <a href="https://passexperten.de/ratgeber/aufenthaltstitel-fuer-einbuergerung" target="_blank">finden Sie in unserem Ratgeber.</a>.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Ich weiß es nicht',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Aufenthaltstitel:</span><p>Aufenthaltstitel reicht nicht für die Einbürgerung aus. Damit Sie den Einbürgerungsprozess starten können, sollten Sie den Aufenthaltstitel zunächst wechseln. Mit folgenden Aufenthaltstitel ist eine Einbürgerung nicht möglich: : §§ 16a, 16b, 16d, 16e, 16f, 17, 18d, 18f, 19, 19b, 19e, 20, 22, 23 Absatz 1, den §§ 23a, 24, 25 Absatz 3 bis 5 und § 104c AufenthG.</p><p><strong>Tipp:</strong> Holen Sie sich bei einer Migrationsberatungsstelle (z. B. Caritas, AWO oder Diakonie) kostenlose Erstberatung zu Ihren Möglichkeiten. Weiterführende Informationen <a href="https://passexperten.de/ratgeber/aufenthaltstitel-fuer-einbuergerung" target="_blank">finden Sie auch in unserem Ratgeber.</a>.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17347: [
                      {
                        value: 'Einbürgerung',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17358:
                                '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 104c',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Sprachkenntnisse:</span><p>Sie haben ein ausreichendes Sprachzertifikat.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17369: [
                      {
                        value: 'B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Ausbildung:</span><p>Ihre Ausbildung in Deutschland ist hoch genug für die notwendigen Integrationsvoraussetzungen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value:
                          '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Ausbildung:</span><p>Sie haben eine deutsche Ausbildung absolviert. Diese reicht für die Einbürgerung nur, wenn:</p><ul><li style="margin-top:12px;">Sie zuvor einen Abschluss der 9. Klasse, 10. Klasse oder das Abitur in Deutschland gemacht haben.</li><li style="margin-top:12px; margin-bottom:12px;">Ihre Ausbildung Kurse in Politik, Verwaltungswissenschaften, Sozialwissenschaften, Rechtswissenschaften oder Gesellschaftskunde enthält.</li></ul><p>Falls Ihr Abschluss nicht ausreicht, empfiehlt es sich, den Einbürgerungstest nachzuholen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value: 'Ausbildung',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17370: '>>>NOT>>>Ja',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Sprachkenntnisse:</span><p>Es ist fraglich, ob Sie ausreichende Deutschkenntnisse besitzen. Fehlen die entsprechenden Sprachnachweise bestehen zwei Möglichkeiten:</p><ol><li style="margin-top:16px;">Es greifen Ausnahmen. <a href="https://passexperten.de/ratgeber/einbuergerung-voraussetzungen/#Deutschkenntnisse" target="_blank">Gängige Ausnahmen finden Sie hier</a>.</li><li style="margin-top:16px;">Sie können den Sprachnachweis nachholen.</li></ol>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value:
                          '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Ausbildung>>>NOT>>>Studium',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17369: '>>>NOT>>>B1>>>NOT>>>B2>>>NOT>>>C1>>>NOT>>>C2',
                            },
                            {
                              q17370: '>>>NOT>>>Ja',
                            },
                          ],
                        },
                      },
                      {
                        value:
                          '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Ausbildung>>>NOT>>>Studium',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17377: 'Nein',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Einbürgerungstest:</span><p>Sie können den Einbürgerungstest vorweisen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17370: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Einbürgerungstest:</span><p>Es ist fraglich, ob Sie die notwendingen Integrationsvoraussetzungen besitzen.</p><p><strong>Tipp:</strong> Melden Sie sich für einen Vorbereitungskurs zum Einbürgerungstest an - viele VHS und Bildungsträger bieten diesen kostenlos oder günstig an.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17370: [
                      {
                        value: 'Nein',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17368:
                                '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Ausbildung>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Studium',
                            },
                            {
                              q17378: 'Nein',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sie beziehen derzeit kein Bürgergeld. Damit sollte eine Einbürgerung möglich sein.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Nein',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sie beziehen derzeit Bürgergeld. Damit ist eine Einbürgerung sehr schwierig. Mögliche Ausnahmen können Sie <a href="https://passexperten.de/news/einbuergerung-buergergeld/" target="_blank">hier nachlesen</a>.</p><p><strong>Tipp:</strong> Beantragen Sie eine Eingliederungsvereinbarung, um aktiv auf Beschäftigung hinzuarbeiten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sollten Sie derzeit Bürgergeld beziehen wäre eine Einbürgerung sehr schwierig. Mögliche Ausnahmen können Sie <a href="https://passexperten.de/news/einbuergerung-buergergeld/" target="_blank">hier nachlesen</a>.</p><p><strong>Tipp:</strong>Beantragen Sie eine Eingliederungsvereinbarung, um aktiv auf Beschäftigung hinzuarbeiten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Keine Angabe',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Pass oder Passersatz:</span><p>Sie können derzeit auf einen gültigen Pass oder Passersatz zurückgreifen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17375: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                      {
                        value: 'Nein',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17376: '>>>NOT>>>Anderes Land',
                            },
                            {
                              otherIdentificationDocument: '>>>NOT>>>Nein',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Pass oder Passersatz:</span><p>Sie können derzeit auf keinen gültigen Pass oder Passersatz zurückgreifen.</p><ol><li style="margin-top:16px;">Sollte es Ihnen möglich sein, beantragen Sie einen gültigen Pass. Wenden Sie sich dazu an die Botschaft oder das Konsulat Ihres Herkunftslandes in Deutschland.</li><li style="margin-top:16px;">Weitere Informationen zur Einbürgerung ohne Pass <a href="https://passexperten.de/news/einbuergerung-ohne-pass/" target="_blank">finden Sie in unserem Ratgeber.</a></li></ol><p><strong>Tipp:</strong> Falls eine Passbeantragung unzumutbar oder unmöglich ist (z. B. bei Verfolgung), dokumentieren Sie dies sorgfältig - es gibt Ausnahmeregelungen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17375: [
                      {
                        value: 'Nein',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17376: 'Anderes Land',
                            },
                          ],
                        },
                      },
                      {
                        value: 'Nein',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17376: '>>>NOT>>>Anderes Land',
                            },
                            {
                              otherIdentificationDocument: 'Nein',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              // {
              //   type: 'question',
              //   content:
              //     '<span>Straftaten:</span><p>Wichtig ist, dass Sie sich nur in geringem Maße in Deutschland strafbar gemacht haben.</p>',
              //   subContent: [],
              //   condition: {
              //     forceResult: 'none',
              //     mode: 'some',
              //     screen: null,
              //     form: {
              //       q17347: [
              //         {
              //           value: 'Einbürgerung',
              //           extra: null,
              //         },
              //       ],
              //     },
              //   },
              // },
            ],
          },
          condition: null,
        },
        {
          variationId: 2,
          content: {
            priority: ['exclamation', 'check', 'cross'],
            content: [
              {
                type: 'check',
                content:
                  '<span>Aufenthalt in Deutschland:</span><p>Es sieht aus als würden Sie die zeitlichen Voraussetzungen erfüllen. Die Berechnung der Aufenthaltszeiten ist allerdings rechtlich kompliziert.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17348: [
                      {
                        value:
                          '2020>>>OR>>>2019>>>OR>>>2018>>>OR>>>2017>>>OR>>>2016>>>OR>>>2015>>>OR>>>2014>>>OR>>>2013>>>OR>>>2012 oder davor',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Aufenthaltstitel:</span><p>Ihr Aufenthaltstitel ist für die Einbürgerung ausreichend.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Unbefristetes Aufenthaltsrecht>>>OR>>>EU-Bürger',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Aufenthaltstitel:</span><p>Ihr Aufenthaltstitel ist für die Einbürgerung ausreichend.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Befristetes Aufenthaltsrecht',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17358:
                                '>>>NOT>>>§ 19d>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 104c',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Sprachkenntnisse:</span><p>Sie haben ein ausreichendes Sprachzertifikat.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17369: [
                      {
                        value: 'B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Ausbildung:</span><p>Ihre Ausbildung in Deutschland ist hoch genug für die notwendigen Integrationsvoraussetzungen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value:
                          '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Ausbildung:</span><p>Sie haben eine deutsche Ausbildung absolviert. Diese reicht für die Einbürgerung nur, wenn:<ul><li style="margin-top:12px;">Sie zuvor einen Abschluss der 9. Klasse, 10. Klasse oder das Abitur in Deutschland gemacht haben.</li><li style="margin-top:12px; margin-bottom:12px;">Ihre Ausbildung Kurse in Politik, Verwaltungswissenschaften, Sozialwissenschaften, Rechtswissenschaften oder Gesellschaftskunde enthält.</li></ul>Falls Ihr Abschluss nicht ausreicht, empfiehlt es sich, den Einbürgerungstest nachzuholen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value: 'Ausbildung',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17370: '>>>NOT>>>Ja',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Einbürgerungstest:</span><p>Sie können den Einbürgerungstest vorweisen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17370: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sie beziehen derzeit kein Bürgergeld. Damit sollte eine Einbürgerung möglich sein.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Nein',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Pass oder Passersatz:</span><p>Sie können derzeit auf einen gültigen Pass oder Passersatz zurückgreifen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17375: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              // {
              //   type: 'question',
              //   content:
              //     '<span>Straftaten:</span><p>Wichtig ist, dass Sie sich nur in geringem Maße in Deutschland strafbar gemacht haben.</p>',
              //   subContent: [],
              //   condition: {
              //     forceResult: 'none',
              //     mode: 'some',
              //     screen: null,
              //     form: {
              //       q17347: [
              //         {
              //           value: 'Einbürgerung',
              //           extra: null,
              //         },
              //       ],
              //     },
              //   },
              // },
            ],
          },
          condition: null,
        },
        {
          variationId: 3,
          content: {
            priority: ['cross', 'exclamation', 'check', 'question'],
            content: [
              {
                type: 'cross',
                content:
                  '<span>Aufenthaltstitel:</span><p>Aufenthaltstitel reicht nicht für die Einbürgerung aus. Damit Sie den Einbürgerungsprozess starten können, sollten Sie den Aufenthaltstitel zunächst wechseln. Mit folgenden Aufenthaltstitel ist eine Einbürgerung nicht möglich: : §§ 16a, 16b, 16d, 16e, 16f, 17, 18d, 18f, 19, 19b, 19e, 20, 22, 23 Absatz 1, den §§ 23a, 24, 25 Absatz 3 bis 5 und § 104c AufenthG.<br><strong>Tipp:</strong> Holen Sie sich bei einer Migrationsberatungsstelle (z. B. Caritas, AWO oder Diakonie) kostenlose Erstberatung zu Ihren Möglichkeiten. Weiterführende Informationen <a href="https://passexperten.de/ratgeber/aufenthaltstitel-fuer-einbuergerung" target="_blank">finden Sie auch in unserem Ratgeber.</a>.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17347: [
                      {
                        value: 'Einbürgerung',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17358:
                                '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 104c',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'cross',
                content:
                  '<span>Aufenthalt in Deutschland:</span><p>Es sieht aus als würden Sie nicht die benötigten fünf Jahre Aufenthalt in Deutschland erfüllen. Eine Einbürgerung wird erstmal nicht möglich sein.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17347: [
                      {
                        value: 'Einbürgerung',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17348: '2026>>>OR>>>2025>>>OR>>>2024',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Duldung:</span><p>Achtung: Wahrscheinlich hatten Sie eine Duldung vor diesem Aufenthaltstitel. Man müsste sich Ihre Aufenthaltszeiten genauer ansehen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17358: [
                      {
                        value: '§ 19d>>>OR>>>§ 25a>>>OR>>>§ 25b',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Fiktionsbescheinigung:</span><p>Sie haben derzeit eine Fiktionsbescheinigung. Das ist kein Problem. Sie sollten allerdings Druck auf die Ausländerbehörde aufbauen. Mit einer Fiktionsbescheinigung können Sie nicht eingebürgert werden. Sie sollten den dafür vorhergesehenen Aufenthaltstitel vorweisen können.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17356: [
                      {
                        value: 'Fiktionsbescheinigung',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Sprachkenntnisse:</span><p>Sie haben ein ausreichendes Sprachzertifikat.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17369: [
                      {
                        value: 'B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Ausbildung:</span><p>Ihre Ausbildung in Deutschland ist hoch genug für den notwendigen Sprachnachweis.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value:
                          '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Ausbildung>>>OR>>>Studium',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Sprachkenntnisse:</span><p>Es ist fraglich, ob Sie ausreichende Deutschkenntnisse besitzen. Fehlen die entsprechenden Sprachnachweise bestehen zwei Möglichkeiten:</p><ol><li style="margin-top:16px;">Es greifen Ausnahmen. <a href="https://passexperten.de/ratgeber/einbuergerung-voraussetzungen/#Deutschkenntnisse" target="_blank">Gängige Ausnahmen finden Sie hier</a>.</li><li style="margin-top:16px;">Sie können den Sprachnachweis nachholen.</li></ol>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17368: [
                      {
                        value:
                          '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Ausbildung>>>NOT>>>Studium',
                        extra: {
                          mode: 'every',
                          condition: [
                            {
                              q17369: '>>>NOT>>>B1>>>NOT>>>B2>>>NOT>>>C1>>>NOT>>>C2',
                            },
                            {
                              q17370: '>>>NOT>>>Ja',
                            },
                          ],
                        },
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content: '<span>Einbürgerungstest:</span><p>Sie können den Einbürgerungstest vorweisen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17370: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sie beziehen derzeit kein Bürgergeld. Damit sollte eine Einbürgerung möglich sein.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Nein',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'exclamation',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sie beziehen derzeit Bürgergeld. Damit ist eine Einbürgerung sehr schwierig. Mögliche Ausnahmen können Sie <a href="https://passexperten.de/ratgeber/einbuergerung-voraussetzungen/#Lebensunterhalt" target="_blank">hier nachlesen</a>.</p><p><strong>Tipp:</strong>Beantragen Sie eine Eingliederungsvereinbarung, um aktiv auf Beschäftigung hinzuarbeiten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'question',
                content:
                  '<span>Gesicherter Lebensunerhalt:</span><p>Sollten Sie derzeit Bürgergeld beziehen wäre eine Einbürgerung sehr schwierig. Mögliche Ausnahmen können Sie <a href="https://passexperten.de/ratgeber/einbuergerung-voraussetzungen/#Lebensunterhalt" target="_blank">hier nachlesen</a>.</p><p><strong>Tipp:</strong>Beantragen Sie eine Eingliederungsvereinbarung, um aktiv auf Beschäftigung hinzuarbeiten.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q18261: [
                      {
                        value: 'Keine Angabe',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              {
                type: 'check',
                content:
                  '<span>Pass oder Passersatz:</span><p>Sie können derzeit auf einen gültigen Pass oder Passersatz zurückgreifen.</p>',
                subContent: [],
                condition: {
                  forceResult: 'none',
                  mode: 'some',
                  screen: null,
                  form: {
                    q17375: [
                      {
                        value: 'Ja',
                        extra: null,
                      },
                    ],
                  },
                },
              },
              // {
              //   type: 'question',
              //   content:
              //     '<span>Straftaten:</span><p>Wichtig ist, dass Sie sich nur in geringem Maße in Deutschland strafbar gemacht haben.</p>',
              //   subContent: [],
              //   condition: {
              //     forceResult: 'none',
              //     mode: 'some',
              //     screen: null,
              //     form: {
              //       q17347: [
              //         {
              //           value: 'Einbürgerung',
              //           extra: null,
              //         },
              //       ],
              //     },
              //   },
              // },
            ],
          },
          condition: null,
        },
      ],
    },
  },
  question: [
    {
      type: PRIO_GROUP_TYPE.QUESTION,
      content: {
        head: () => (
          <>
            <b className='question__bold'>Wie geht es jetzt weiter?</b>
          </>
        ),
        body: () => (
          <>
            <ol className='question__list'>
              <li className='question__list-item'>
                Sie stellen sicher, dass sie alle Voraussetzungen für den Antrag erfüllen. Sollten Sie Fragen haben,
                können Sie uns eine{' '}
                <a
                  onClick={() => Track.DataLayer.LongReadWhatsappClick()}
                  href='https://wa.me/491735342762'
                  target='_blank'
                >
                  Kontaktanfrage über Whatsapp
                </a>{' '}
                schicken.
              </li>
              <li className='question__list-item'>
                <strong>Wir melden uns in 6 Monaten bei Ihnen</strong> - vielleicht hat sich bis dann etwas verändert.
                Bitte prüfen Sie auch Ihren Spam-Ordner, die E-Mail kommt mit dem Betreff "Update zu Ihrem deutschen
                Pass".
              </li>
              <li className='question__list-item'>
                Sobald Sie alle oberen Punkte erfüllen, führen Sie erneut unseren{' '}
                <a href='https://passexperten.de/pruefer/' target='_blank'>
                  kostenlosen Test
                </a>{' '}
                aus.
              </li>
            </ol>
          </>
        ),
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // Pass #1
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Anderes Land',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Pass #2
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: '>>>NOT>>>Anderes Land',
                  },
                  {
                    otherIdentificationDocument: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Aufenthaltsdauer
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17348: '2022>>>OR>>>2023>>>OR>>>2024>>>OR>>>2025>>>OR>>>2026>>>OR>>>Keine Angabe',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Befristeter Aufenthalt
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17358:
                      '§ 16a>>>OR>>>§ 16b>>>OR>>>§ 16d>>>OR>>>§ 16e>>>OR>>>§ 16f>>>OR>>>§ 17>>>OR>>>§ 18f>>>OR>>>§ 19>>>OR>>>§ 19b>>>OR>>>§ 19d>>>OR>>>§ 19e>>>OR>>>§ 20>>>OR>>>§ 22>>>OR>>>§ 23a>>>OR>>>§ 24>>>OR>>>§ 25 Abs. 3>>>OR>>>§ 25 Abs. 4>>>OR>>>§ 25 Abs. 5>>>OR>>>§ 25a>>>OR>>>§ 25b>>>OR>>>§ 104c>>>OR>>>Sonstiges',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Aufenthaltstitel
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17356: 'Duldung>>>OR>>>Fiktionsbescheinigung>>>OR>>>Ich weiß es nicht',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17368:
                      '>>>NOT>>>9. Klasse Abschluss>>>NOT>>>10. Klasse Abschluss>>>NOT>>>Abitur oder Fachabitur>>>NOT>>>Studium',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Sprachnachweis
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>Kein deutsches Sprachzertifikat',
                  },
                  {
                    q17377: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Einbürgerungstest
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17370: 'Nein',
                  },
                  {
                    q17378: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Bürgergeld
              extra: {
                mode: 'every',
                condition: [
                  {
                    q18261: '>>>NOT>>>Nein',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      type: PRIO_GROUP_TYPE.QUESTION,
      content: {
        head: () => (
          <>
            <b className='question__bold'>Wie geht es jetzt weiter?</b> Was sind die nächsten Schritte?
          </>
        ),
        body: () => (
          <>
            <ol className='question__list'>
              <li className='question__list-item'>
                Kontaktieren Sie uns für eine{' '}
                <a
                  onClick={() => Track.DataLayer.LongReadWhatsappClick()}
                  href='https://wa.me/491735342762'
                  target='_blank'
                >
                  kostenlose und unverbindliche Erstberatung
                </a>
                .
              </li>
              <li className='question__list-item'>
                Wenn Sie interessiert sind, helfen wir Ihnen, Ihre Einbürgerung schnell und zuverlässig zu erhalten.
              </li>
            </ol>
          </>
        ),
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // Pass und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Pass und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      type: PRIO_GROUP_TYPE.QUESTION,
      content: {
        head: () => (
          <>
            <b className='question__bold'>Frage:</b> Warum soll ich PassExperten mit der Einbürgerung beauftragen?
          </>
        ),
        body: () => (
          <>
            <p className='question__paragraph'>
              Die Einbürgerung ist ein komplexer und zeitaufwendiger Prozess. Ohne professionelle Unterstützung kann die
              Bearbeitung durch die Behörden mehrere Jahre dauern. Mit PassExperten profitieren Sie von einer
              schnelleren und rechtssicheren Einbürgerung durch unsere erfahrenen Anwälte.
            </p>
            <b className='question__bold'>Ihre Vorteile mit PassExperten:</b>
            <p></p>
            <ol className='question__list'>
              <li className='question__list-item'>
                <b className='question__bold'>Schnellere Bearbeitung:</b> Durch vollständige und fehlerfreie
                Antragstellung reduziert sich die Bearbeitungszeit deutlich.
              </li>
              <li className='question__list-item'>
                <b className='question__bold'>Rechtssicherheit:</b> Unsere spezialisierten Anwälte prüfen Ihre
                Voraussetzungen vor Antragstellung und vermeiden unnötige Ablehnungen.
              </li>
              <li className='question__list-item'>
                <b className='question__bold'>Volle Unterstützung:</b> Wir übernehmen die gesamte Kommunikation mit den
                Behörden, helfen bei der Beschaffung fehlender Dokumente und setzen uns für eine beschleunigte
                Bearbeitung ein.
              </li>
              <li className='question__list-item'>
                <b className='question__bold'>Schutz vor Verzögerungen:</b> Sollte Ihre Behörde nicht reagieren, können
                wir eine <b className='question__bold'>Untätigkeitsklage</b> einreichen, um den Prozess zu
                beschleunigen.
              </li>
              <li className='question__list-item'>
                <b className='question__bold'>Transparente Kosten:</b> Nach einer{' '}
                <b className='question__bold'>kostenlosen Erstberatung</b> erhalten Sie ein Festpreisangebot - ohne
                versteckte Gebühren.
              </li>
            </ol>
          </>
        ),
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung', // Pass und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17368:
                      '9. Klasse Abschluss>>>OR>>>10. Klasse Abschluss>>>OR>>>Abitur oder Fachabitur>>>OR>>>Studium>>>OR>>>Ausbildung',
                  },

                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Pass und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Ja',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung', // Identitätsdokument und keine Ausbildung
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17375: 'Nein',
                  },
                  {
                    q17376: 'Afghanisch>>>OR>>>Eritreisch>>>OR>>>Somalisch>>>OR>>>Syrisch',
                  },
                  {
                    otherIdentificationDocument: '>>>NOT>>>Nein',
                  },
                  {
                    q17348: '>>>NOT>>>2022>>>NOT>>>2023>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026>>>NOT>>>Keine Angabe',
                  },
                  {
                    q17358:
                      '>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19d>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 104c>>>NOT>>>Sonstiges',
                  },
                  {
                    q17356: '>>>NOT>>>Duldung>>>NOT>>>Ich weiß es nicht',
                  },
                  {
                    q17369: 'A1>>>OR>>>A2>>>OR>>>B1>>>OR>>>B2>>>OR>>>C1>>>OR>>>C2',
                  },
                  {
                    q17377: '>>>NOT>>>Nein',
                  },
                  {
                    q17370: 'Ja>>>OR>>>Nein',
                  },
                  {
                    q17378: '>>>NOT>>>Nein',
                  },
                  {
                    q18261: 'Nein',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      type: PRIO_GROUP_TYPE.REVIEW,
      content: {
        head: null,
        body: () => <Review />,
      },
      condition: {
        forceResult: 'fail',
        mode: 'some',
        screen: {
          moreThan: 768,
          lessThan: null,
        },
        form: {
          q17347: [
            {
              value: 'ToDo',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17348: '>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026',
                  },
                ],
              },
            },
            {
              value: 'ToDo',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17358:
                      '>>>NOT>>>§ 19d>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 104c',
                  },
                ],
              },
            },
          ],
        },
      },
    },
    {
      type: PRIO_GROUP_TYPE.ACCORDION,
      content: {
        head: () => (
          <>
            <b className='question__bold'>FAQ:</b> Häufig gestellte Fragen
          </>
        ),
        body: () => (
          <Accordion
            blocks={[
              {
                title: 'Wie läuft das Verfahren ab?',
                content:
                  "<p class='question__paragraph'>Das Verfahren zur Beantragung einer Niederlassungserlaubnis oder Einbürgerung gliedert sich in mehrere Schritte:</p><ol class='question__list'><li class='question__list-item'><b class='question__bold'>Antragstellung:</b>  Wir stellen den Antrag auf Niederlassungserlaubnis oder Einbürgerung.</li><li class='question__list-item'><b class='question__bold'>Prüfung des Antrags durch die Ausländer- oder Einbürgerungsbehörde:</b> Die Ausländer- oder Einbürgerungsbehörde prüft Ihren Antrag, um sicherzustellen, dass alle erforderlichen Unterlagen vollständig sind und den rechtlichen Anforderungen entsprechen.</li><li class='question__list-item'><b class='question__bold'>Erteilung der Niederlassungserlaubnis oder Einbürgerung:</b> Nach erfolgreicher Prüfung und Erfüllung aller erforderlichen Voraussetzungen wird Ihnen die Niederlassungserlaubnis oder Einbürgerung erteilt. Damit ist Ihr Verfahren abgeschlossen</li></ol><p>Verläuft Ihr Verfahren schleppend, greifen wir ein. Mithilfe einer Untätigkeitsklage bauen wir Druck auf und zwingen die Behörde so zu einer zeitnahmen entscheidung.</p><p>Auch im <b class='question__bold'>Falle einer Ablehnung</b> lassen wir Sie nicht allein: Wir klagen gegen eine derartige Entscheidung und fordern so Korrektur ein.</p>",
                condition: null,
              },
              {
                title: 'Wie lange dauert das Verfahren?',
                content:
                  "<p class='question__paragraph'>Die Dauer eines Einbürgerungsverfahrens hängt von unterschiedlichen Faktoren ab. Maßgeblich ist dabei, die Vollständigkeit Ihres Antrages. Muss die Behörde fehelnde Unterlagen nachfordern, kann sich die Bearbeitung Ihres Antrages stark in die Länge ziehen. Wir sorgen dafür, dass das nicht passiert. Im Vorfeld klären wir genau ab, welche Dokumente von Ihnen bei den Behörden einzureichen sind. Bei Bedarf unterstützen wir Sie auch bei der Beschaffung fehlender Unterlagen. So halten wir die Verfahrenszeiten möglichst kurz, mit mehreren Monaten müssen Sie dennoch rechnen</p><p>Verzögerungen im Einbürgerungsverahren sind jedch auch bei vollständigen Anträgen keine Seltenheit. Viele Einbürgerungsbehörden sind überlastet und kommen nicht gegen die Vielzahl der Anträge an. Ohne anwaltliche Unterstützung ziehen sich die Verfahrenszeiten dabei schon mal deutlich über ein Jahr hin.</p>",
                condition: null,
              },
              {
                title: 'Welche Unterlagen werden benötigt?',
                content:
                  "<p class='question__paragraph'>Welche Unterlagen wir beziehungsweise die Ausländer- oder Einbürgerungsbehörde von Ihnen benötigt, lässt sich nicht pauschal sagen. Das hängt von Ihrer persönlichen Situation ab. Wir prüfen Ihre Umstände und informieren Sie darüber, welche Nachweise für Ihr Anliegen erforderlich sind. Zudem unterstützen wir Sie bei der beschaffung fehlender Unterlagen. Sprechen Sie uns gerne an.</p>",
                condition: null,
              },
              // {
              //   title: 'Welche Voraussetzungen muss ich für die Einbürgerung erfüllen?',
              //   content:
              //     "<p class='question__paragraph'>Die Einbürgerung ist an verschiedene Voraussetzungen gebunden. Darunter finden sich zum Beispiel:</p><ul class='question__list'><li class='question__list-item'>ein mindestens 5-jähriger Aufenthalt in Deuschland,</li><li class='question__list-item'>ein gültiger Aufenthaltstitel,</li><li class='question__list-item'>ausreichende Deutschkenntnisse und</li><li class='question__list-item'>ein gesicherter Lebensunterhalt.</li></ul><p><a href=\"https://passexperten.de/ratgeber/einbuergerung-voraussetzungen/\" target=\"_blank\">Einbürgerung und ihre Voraussetzungen</a> finden Sie eine komplette Auflistung aller Bedingungen mit weterführenden Informationen.</p>",
              //   condition: null,
              // },
              {
                title: 'Ich habe noch keinen Einbürgerungstest gemacht. Kann ich trotzdem schon den Antrag stellen?',
                content:
                  "<p class='question__paragraph'>Wichtig ist, dass der Einbürgerungstest zu dem Zeitpunkt vorliegt, an dem die Behörde über Ihren Antrag entscheidet. Aufgrund der langen Bearbeitungszeiten kann es sinnvoll sein, den Antrag zu stellen, bevor der Einbürgerungstest gemacht wurde. Das Ergebnis können Sie nachreichen. Wir können jedoch nur Fälle aufnehmen, bei denen der Einbürgerungstest vorliegt oder äquivalente Kriterien (z. Bsp. einen deutschen Abschluss) erfüllt sind.</p>",
                condition: null,
              },
            ]}
          />
        ),
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'Einbürgerung',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17348: '>>>NOT>>>2024>>>NOT>>>2025>>>NOT>>>2026',
                  },
                ],
              },
            },
            {
              value: 'Einbürgerung',
              extra: {
                mode: 'every',
                condition: [
                  {
                    q17358:
                      '§ 19d>>>NOT>>>§ 25a>>>NOT>>>§ 25b>>>NOT>>>§ 16a>>>NOT>>>§ 16b>>>NOT>>>§ 16d>>>NOT>>>§ 16e>>>NOT>>>§ 16f>>>NOT>>>§ 17>>>NOT>>>§ 18f>>>NOT>>>§ 19>>>NOT>>>§ 19b>>>NOT>>>§ 19e>>>NOT>>>§ 20>>>NOT>>>§ 22>>>NOT>>>§ 23a>>>NOT>>>§ 24>>>NOT>>>§ 25 Abs. 3>>>NOT>>>§ 25 Abs. 4>>>NOT>>>§ 25 Abs. 5>>>NOT>>>§ 104c',
                  },
                ],
              },
            },
          ],
        },
      },
    },
  ],
  sidebar: [
    {
      type: PRIO_GROUP_TYPE.ORDERED_LIST,
      content: {
        head: null,
        body: () => <OrderedList />,
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: {
          moreThan: null,
          lessThan: 1,
        },
        form: null,
      },
    },
    {
      type: PRIO_GROUP_TYPE.CTA_BUTTON,
      content: {
        head: null,
        body: () => <CtaButton fullWidth />,
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: {
          moreThan: null,
          lessThan: 1,
        },
        form: null,
      },
    },
    {
      type: PRIO_GROUP_TYPE.LOGOS,
      content: {
        head: null,
        body: () => {
          const cssVersion = useAppSelector(ConfigSlice.selectors.cssVersion);
          return cssVersion === 1 ? <Logos /> : <Certifications />;
        },
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: {
          moreThan: null,
          lessThan: 1,
        },
        form: null,
      },
    },
    {
      type: PRIO_GROUP_TYPE.CONTACT_US,
      content: {
        head: null,
        body: () => <Contact />,
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: {
          moreThan: null,
          lessThan: 1,
        },
        form: null,
      },
    },
  ],
  footer: [
    {
      type: PRIO_GROUP_TYPE.ADVANTAGE_LIST_NO_BUTTON,
      content: {
        head: null,
        body: () => <Advantages withoutButton />,
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: {
          moreThan: null,
          lessThan: 1,
        },
        form: null,
      },
    },
    {
      type: PRIO_GROUP_TYPE.CONTACT_US,
      content: {
        head: null,
        body: () => <Contact />,
      },
      condition: {
        forceResult: 'none',
        mode: 'some',
        screen: null,
        form: {
          q17347: [
            {
              value: 'ToDo',
              extra: null,
            },
          ],
        },
      },
    },
  ],
};

export default prio;
